import { MDBBtn, MDBInput, MDBModalFooter, MDBSelect, MDBTextArea, MDBIcon, MDBAutocomplete, MDBAlert, MDBSpinner } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Voice1 from "../../uimedia/lunavoices/Alloy_aka_Luna_tts-1-hd.mp3"
import Voice2 from "../../uimedia/lunavoices/Echo_aka_Eric_tts-1-hd.mp3"
import Voice3 from "../../uimedia/lunavoices/Ash_aka_Oscar_tts-1-hd.mp3"
import Voice4 from "../../uimedia/lunavoices/Shimmer_aka_Serena_tts-1-hd.mp3"
import { Controller, useForm } from 'react-hook-form';
import { sanitizeAndLowercase } from '../../apiclients/CommonUtils';
import { getGreetingWavFile, uploadEditGreeting, uploadGreeting } from '../../apiclients/streamsapi_bridge';
import TTSGenerationPopup from '../../components/TTSGenerationPopup';
import UIConstant from '../../apiclients/UIConstant';

const TexttoSpeech = (props) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);

    // TTS Generation Popup states
    const [showTTSGeneration, setShowTTSGeneration] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);


    const voices = [
        { voiceid: 1, voiceurl: Voice1, title: "Luna" },
        { voiceid: 2, voiceurl: Voice2, title: "Eric" },
        { voiceid: 3, voiceurl: Voice3, title: "Oscar" },
        { voiceid: 4, voiceurl: Voice4, title: "Serena" }
    ];

    const [displayLunaVoices, setdisplayLunaVoices] = useState(voices);
    const [voiceValue, setvoiceValue] = useState("Luna");
    const [playVoiceId, setplayVoiceId] = useState("");
    const audioRef = useRef(null); // Ref to the audio element
    const [isPlaying, setIsPlaying] = useState(false); // To track if the audio is playing
    const [wavFile, setwavFile] = useState(null);
    const [oldText, setoldText] = useState("");
    const [blobURL, setBlobURL] = useState(null);
    const [wavFilePath, setwavFilePath] = useState("");
    const [isAudioPlaying, setisAudioPlaying] = useState(false);
    const [wavFileName, setwavFileName] = useState("");
    const [oldVoiceType, setoldVoiceType] = useState(1);
    const [isStreamingAudio, setIsStreamingAudio] = useState(false);

    const { register, watch, control, setValue, handleSubmit, formState: { errors, isDirty, dirtyFields }, setError, clearErrors, reset } = useForm({
        defaultValues: {
            greeting_type: 3,
            name: "",
            text: "",
            filename: "",
            voice_type: 1,
        }
    });

    // const textValue = watch("text") || "";
    const maxChars = UIConstant.MAX_CHAR_MEDIA;
    const maxCharsHunt = UIConstant.MAX_CHAR_MEDIA_HUNT;
    const handlePlayAudio = (e, audioUrl, voiceid) => {
        e.preventDefault();
        e.stopPropagation();
        setplayVoiceId(voiceid);
        if (audioRef.current) {
            audioRef.current.pause(); // Pause the audio
            audioRef.current.currentTime = 0; // Reset to the start
            setIsPlaying(false); // Update the state
        }

        // Set the new audio source and play it
        if (audioRef.current) {
            audioRef.current.src = audioUrl;
            audioRef.current.play();
            setIsPlaying(true); // Update the state to reflect audio is playing
        }
    };

    const handlePauseAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
            setplayVoiceId("");
            setisAudioPlaying(false);
        }

    }
    useEffect(() => {
        if (props.isActive && props?.mediaInfo && Object.keys(props.mediaInfo).length > 0 && props?.mediaInfo?.uploadType === "Text To Speech") {
            setvoiceValue(voices.find(v => v.voiceid === props?.mediaInfo?.voice_type)?.title || "Luna");
            reset({
                greeting_type: props?.mediaInfo?.greeting_type || 3,
                name: props?.mediaInfo?.name || "",
                text: props?.mediaInfo?.text || "",
                filename: props?.mediaInfo?.filename || "",
                voice_type: props?.mediaInfo?.voice_type || 1,
            });
        } else if (props.isActive) {
            reset({
                greeting_type: 3,
                name: "",
                text: "",
                filename: "",
                voice_type: 1,
            });
        }

    }, [props.isActive, props?.mediaInfo]);

    function handleVoiceSelect(value) {

        setvoiceValue(value);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        }
        setplayVoiceId("");
        const voice = voices.find(v => v.title === value);

        if (voice) {
            setValue("voice_type", parseInt(voice.voiceid), { shouldDirty: true });
        }
    }


    const playMiscFile = (e, message) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (message && message.trim() !== "") {
            // const reqyiredmMxChar = watch("greeting_type") === 5 ? maxCharsHunt : maxChars;
            const reqyiredmMxChar = maxChars;
            if (message.length > reqyiredmMxChar) {
                setError("text", {
                    message: `Maximum ${reqyiredmMxChar} characters are allowed`,
                });
                return;
            }
            // Show TTS generation popup
            // setShowTTSGeneration(true);
            getAudioFileInfo(message);
        }
    };
    const getAudioFileInfo = async (message) => {
        try {
            if (blobURL) URL.revokeObjectURL(blobURL);
            setBlobURL(null);
            audioRef.current?.pause();
            if (audioRef.current) audioRef.current.currentTime = 0;

            const normalizedMessage = await sanitizeAndLowercase(message);
            let apiResponse = null;


            if (
                wavFile &&
                normalizedMessage === oldText &&
                parseInt(watch("voice_type")) === parseInt(oldVoiceType)
            ) {
                setisAudioPlaying(true);
                const exitfileUrl = URL.createObjectURL(wavFile);
                setBlobURL(exitfileUrl);
                // setIsGenerating(false); // Hide generation popup for existing file
                // setShowTTSGeneration(false);
                return;
            }

            // setIsloading(true);
            setShowTTSGeneration(true);
            setIsGenerating(true);
            apiResponse = await getAudioFile(message);
            // setIsloading(false);
            setShowTTSGeneration(false);
            setIsGenerating(false); // Hide generation popup
            if (apiResponse?.status === 200) {
                // ✅ MediaSource for fast streaming playback
                const mediaSource = new MediaSource();
                const objectURL = URL.createObjectURL(mediaSource);
                setBlobURL(objectURL);
                setisAudioPlaying(true);
                setIsStreamingAudio(true);

                mediaSource.addEventListener("sourceopen", async () => {
                    const mimeType = "audio/mpeg"; // or "audio/wav" if backend returns WAV
                    const sourceBuffer = mediaSource.addSourceBuffer(mimeType);
                    mediaSource.duration = 0;

                    const reader = apiResponse.body.getReader();
                    const chunks = [];

                    const pump = async () => {
                        const { done, value } = await reader.read();

                        if (done) {
                            // ✅ Wait for last update to finish before ending stream
                            if (sourceBuffer.updating) {
                                sourceBuffer.addEventListener(
                                    "updateend",
                                    () => mediaSource.endOfStream(),
                                    { once: true }
                                );
                            } else {
                                mediaSource.endOfStream();
                            }

                            // ✅ Build full Blob for caching
                            const finalBlob = new Blob(chunks, { type: mimeType });
                            const fileUrl = URL.createObjectURL(finalBlob);

                            setwavFile(finalBlob);
                            setwavFilePath(fileUrl);
                            setIsStreamingAudio(false);

                            // Extract filename if present
                            const contentDisposition = apiResponse.headers.get("Content-Disposition");
                            if (contentDisposition) {
                                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                                if (match && match[1]) {
                                    setwavFileName(match[1]);
                                }
                            }

                            return;
                        }

                        chunks.push(value);

                        // Wait until sourceBuffer is free
                        await new Promise((resolve) => {
                            if (!sourceBuffer.updating) return resolve();
                            sourceBuffer.addEventListener("updateend", resolve, { once: true });
                        });

                        sourceBuffer.appendBuffer(value);
                        pump();
                    };

                    pump();
                });

                // Keep your old metadata state
                setoldText(normalizedMessage);
                setoldVoiceType(parseInt(watch("voice_type")));
            } else {
                props?.setinterErrorMessage(apiResponse?.message ?? "Internal Server Error");
                setIsGenerating(false);
                setShowTTSGeneration(false);
                setIsStreamingAudio(false);
            }
        } catch (error) {
            console.error("Unable to load audio file:", error);
            setIsGenerating(false);
            setShowTTSGeneration(false);
            setIsStreamingAudio(false);
        }
    };

    async function getAudioFile(message) {
        try {
            let reqBodyInfo = {
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                text: message,
                voice_type: parseInt(watch("voice_type")),
            };

            console.log(
                "request to play :::::::::::::: " + JSON.stringify(reqBodyInfo)
            );
            let apiResponse = await getGreetingWavFile(reqBodyInfo);
            return apiResponse;
        } catch (error) {
            console.log(`Unable to load the audio file : ${error}`);
        }
        return "";
    }

    useEffect(() => {
        if (!props.isActive) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            setIsPlaying(false);
            setplayVoiceId("");
            setisAudioPlaying(false);
        }
    }, [props.isActive]);

    const onSubmit = async (data) => {
        try {
            props?.setinterErrorMessage("");

            if (isDirty) {
                setIsloading(true);
                const formData = new FormData();
                let apiResponse = null;
                if (props?.mediaInfo && Object.keys(props.mediaInfo).length > 0) {
                    const formData = new FormData();
                    const adminSession = JSON.parse(sessionStorage.getItem("admin_session"));

                    // Add required base fields
                    formData.append("siteid", adminSession.siteid);
                    formData.append("greeting_id", props.mediaInfo.greeting_id);
                    formData.append("greeting_type", props.mediaInfo.greeting_type);
                    formData.append("logined_user", JSON.parse(sessionStorage.getItem("admin_session")).logined_user);

                    // Add modified fields directly to FormData
                    for (const field of Object.keys(dirtyFields)) {
                        if (dirtyFields[field] && data.hasOwnProperty(field)) {
                            const value = data[field];

                            // Skip null or undefined values
                            if (value === null || value === undefined) {
                                continue;
                            }

                            // Handle nested objects (flatten them)
                            if (typeof value === "object" && !Array.isArray(value) && !(value instanceof File)) {
                                for (const subfield of Object.keys(dirtyFields[field])) {
                                    if (value.hasOwnProperty(subfield)) {
                                        formData.append(subfield, value[subfield]);
                                    }
                                }
                            }
                            // Handle File objects
                            else if (value instanceof File) {
                                formData.append(field, value);
                            }
                            // Handle arrays
                            else if (Array.isArray(value)) {
                                formData.append(field, JSON.stringify(value));
                            }
                            // Handle primitive values
                            else {
                                formData.append(field, value);
                            }
                        }
                    }

                    if (dirtyFields.text && !dirtyFields.voice_type) {
                        formData.append("voice_type", data.voice_type);
                    } else if (!dirtyFields.text && dirtyFields.voice_type) {
                        formData.append("text", data.text);
                    }


                    if (!isStreamingAudio && oldText === sanitizeAndLowercase(data.text) && parseInt(oldVoiceType) === parseInt(data.voice_type)) {
                        formData.append("greeting", wavFile, data.filename ? data.filename + ".mp3" : data.name + ".mp3");

                        formData.append("filetype", "mp3");
                    }

                    console.log("Submitting media update with modified fields");

                    apiResponse = await uploadEditGreeting(formData);
                } else {

                    formData.append("siteid", JSON.parse(sessionStorage.getItem("admin_session")).siteid);
                    formData.append("logined_user", JSON.parse(sessionStorage.getItem("admin_session")).logined_user);
                    formData.append("greeting_type", data.greeting_type);
                    formData.append("voice_type", data.voice_type);
                    formData.append("uploadtype", 3);
                    formData.append("name", data.name);
                    // formData.append("filename", data.filename + ".wav");
                    formData.append("text", data.text);
                    if (!isStreamingAudio && oldText === sanitizeAndLowercase(data.text) && parseInt(oldVoiceType) === parseInt(data.voice_type)) {
                        formData.append("greeting", wavFile, data.filename ? data.filename + ".mp3" : data.name + ".mp3");
                        //formData.append("filename", wavFileName);
                        //formData.append("filetype", "." + wavFileName.split(".")[1]);
                        formData.append("filetype", "mp3");
                    }

                    apiResponse = await uploadGreeting(formData);
                }
                setTimeout(() => { setIsloading(false) }, 1000);
                let resdata = await apiResponse.json();
                if (apiResponse.status == 200) {
                    localStorage.setItem("s_message", resdata.message); // successfully uploaded.
                    props.onClose();
                    window.location.href = "/medialanding";
                } else if (apiResponse.status === 204 || apiResponse.status === 403 || apiResponse.status === 400 || apiResponse.status === 500) {
                    props?.setinterErrorMessage(resdata.message);
                } else {
                    localStorage.setItem("f_message", resdata.message);
                    props.onClose();
                    window.location.href = "/medialanding";
                }
                console.log(`uploadFile -> JSON Response:${JSON.stringify(resdata)}`);
            }
        } catch (error) {
            props?.setinterErrorMessage('Internal Server Error');
        }
    }

    // const charLimit =
    //     watch("greeting_type") === 5 ? maxCharsHunt : maxChars;
    const charLimit = maxChars;

    const textValue = watch("text") || "";

    return (
        <>
            {/* <div class="tel-numbers"><strong>{t("Greeting_Type_txt")}</strong></div>
            <MDBSelect
                disabled={props?.mediaInfo && props?.mediaInfo?.uploadType === "Text To Speech"}
                data={[
                    { text: 'MOH_IVR', value: 3 },
                    { text: 'IVR Greeting', value: 4 },
                    { text: 'Announcement Greeting', value: 5 },
                ]}
                value={watch("greeting_type")}
                onChange={(e) => setValue("greeting_type", e.value, { shouldDirty: true })}
            /> */}
            <div class="tel-numbers mt-2"><strong>Name:<span className='text-danger'>*</span></strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2'>
                    <MDBInput
                        placeholder="Name"
                        {...register("name", {
                            required: "Name is required",
                            pattern: {
                                value: /^.{1,60}$/,
                                message: "The name is invalid. It must not exceed a maximum number of 60 characters."
                            }
                        })}
                        maxLength={60}
                    />
                    {errors.name && <p className="text-danger">{errors.name.message}</p>}
                </div>
            </div>
            {/* <div class="tel-numbers mt-2"><strong>File Name:<span className='text-danger'>*</span></strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2'>
                    <MDBInput
                        placeholder="File Name"
                        {...register("filename", {
                            required: "File Name is required",
                            pattern: {
                                value: /^[a-zA-Z0-9_-]*$/,
                                message: "Invalid File name. Only letters, numbers, underscores, hyphens are allowed."
                            }
                        },)}
                        maxLength={30}
                    />
                    <p className='text-secondary small'>Greeting file name can be alphanumeric and can include underscore(_) and hyphen(-)</p>

                    {errors.filename && <p className="text-danger">{errors.filename.message}</p>}
                </div>
            </div> */}
            <div class="tel-numbers mt-2"><strong>Voice:</strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2 position-relative'>
                    <MDBAutocomplete
                        data={displayLunaVoices}
                        placeholder='Select Voice'
                        displayValue={(row) => row.title}
                        value={voiceValue}
                        onSelect={(value) => handleVoiceSelect(value)}
                        itemContent={(result) => (
                            <div className='autocomplete-custom-item-content w-100'>
                                <div className='d-flex align-items-center w-100'>
                                    <div className='autocomplete-custom-item-title w-40'>{result.title}</div>
                                    <MDBIcon
                                        far
                                        icon={playVoiceId === result.voiceid ? "pause-circle" : "play-circle"}
                                        className='ms-2'
                                        size='lg'
                                        color='primary'
                                        onClick={(e) => {
                                            if (playVoiceId === result.voiceid) {
                                                handlePauseAudio(e);
                                            } else {
                                                handlePlayAudio(e, result.voiceurl, result.voiceid);
                                            }
                                        }
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    />
                    <div className='position-absolute top-50 translate-middle' style={{ right: "15px" }}>
                        <MDBIcon fas icon='caret-down' color='secondary' />
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-between">
                <strong>Enter Your Message :</strong>
                <div className='cursor-pointer' onClick={(e) => {
                    if (isAudioPlaying) {
                        handlePauseAudio(e);
                    } else {
                        playMiscFile(e, watch(`text`));
                    }
                }}>
                    <MDBIcon far icon={isAudioPlaying ? "pause-circle" : "play-circle"} color='primary' className='me-2' />
                    Preview
                </div>
            </div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2'>
                    {/* <MDBTextArea
                        rows={5}
                        style={{ minHeight: '75px' }}
                        placeholder="Enter Your Message "
                        value={watch("text")}
                        maxLength={watch("greeting_type") === 5 ? maxCharsHunt : maxChars}
                        {...register("text", {
                            required: "Message is required", maxLength: {
                                value: watch("greeting_type") === 5 ? maxCharsHunt : maxChars,
                                message: `Message cannot exceed ${watch("greeting_type") === 5 ? maxCharsHunt : maxChars} characters.`
                            }
                        })}
                        onChange={(e) => setValue("text", e.target.value, { shouldDirty: true, shouldValidate: true, })}
                    /> */}
                    <Controller
                        name="text"
                        control={control}
                        rules={{
                            required: "Message is required",
                            maxLength: {
                                value: charLimit,
                                message: `Message cannot exceed ${charLimit} characters.`,
                            },
                        }}
                        render={() => (
                            <MDBTextArea
                                rows={5}
                                style={{ minHeight: "75px" }}
                                placeholder="Enter Your Message"
                                value={watch("text")}
                                onChange={(e) => {
                                    const sanitized = e.target.value
                                        .replace(/\n/g, ' ')
                                        .replace(/\s+/g, ' ')
                                        .slice(0, charLimit);
                                    setValue("text", sanitized, {
                                        shouldDirty: true,
                                        shouldValidate: true,
                                    });
                                }}
                            />
                        )}
                    />
                    {errors.text && <p className="text-danger">{errors.text.message}</p>}
                    <small className="text-muted text-end d-inline-block w-100">
                        {textValue.length}/{charLimit}
                    </small>
                </div>
            </div>
            <MDBModalFooter className='p-0 pt-2 mt-2'>
                <MDBBtn color='secondary' onClick={(e) => { clearErrors(); props?.setinterErrorMessage(""); reset(); props.setmediaInfo({}); props.onClose(e); }}>
                    {t("close")}
                </MDBBtn >
                <MDBBtn disabled={props?.mediaInfo && Object.keys(props.mediaInfo).length > 0 && props?.mediaInfo?.uploadType === "Text To Speech" && !isDirty} onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleSubmit(onSubmit)() }} >{t("Done")}</MDBBtn>
            </MDBModalFooter>
            {props?.interErrorMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => { props?.setinterErrorMessage("") }}
                >
                    {props?.interErrorMessage}
                </MDBAlert>
            )}
            <audio
                ref={audioRef}
                src={blobURL}
                hidden
                autoPlay
                onEnded={handlePauseAudio}
            />
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {/* TTS Generation Popup */}
            <TTSGenerationPopup
                isOpen={showTTSGeneration}
                onClose={() => setShowTTSGeneration(false)}
                onCancel={() => {
                    setIsGenerating(false);
                    setShowTTSGeneration(false);
                }}
                isGenerating={isGenerating}
            />
        </>
    )
}

export default TexttoSpeech
